module.exports = __webpack_public_path__ + "media/images/product_lines/i2-d9a960f3fcf5516810b0a1ab06510dcc.svg";